<template>
  <div class="modal new-proposal-editor animated fadeIn" :class="{ 'is-active': $route.path.indexOf('/module/') > -1 }">
    <div class="modal-background"></div>

    <document-editor-main :payload="module" :document-loaded="moduleLoaded" :show-module-sidebar="showModuleSidebar">
      <form slot="document-title" class="document-title-wrapper">
        <div class="label">
          <span class="page-header" @click="$router.push('/a/modules')">
            <i class="icon icon-arrow-left"></i>
            {{ $t('navigation.modules') }} /
          </span>
          <input type="text" name="module-title" :placeholder="$t('general.add_title_here')" v-model="module.title">
          <span class="click-to-edit">{{ $t('general.click_to_edit') }}</span>
        </div>
      </form>
    </document-editor-main>

    <transition enter-active-class="animated slideInRight" leave-active-class="animated slideOutRight">
      <div class="is-hidden-mobile show-sidebar" v-if="!showModuleSidebar">
        <a class="button" @click="showModuleSidebar = true">
          <span><i class="icon icon-edit"></i></span>
        </a>
      </div>
    </transition>

    <transition enter-active-class="animated slideInRight" leave-active-class="animated slideOutRight">
      <module-editor-sidebar :payload="module" @save="saveModule()" @closeModuleSidebar="showModuleSidebar = false" v-if="showModuleSidebar">
        <p slot="editor-title">{{ $t('module_editor.module_editor') }}</p>
      </module-editor-sidebar>
    </transition>

  </div>
</template>

<script>
  import API from 'mixins/api';
  import DocumentEditorMain from '../partials/document-editor-main.vue';
  import ModuleEditorSidebar from '../partials/module-editor-sidebar.vue';

  export default {
    mixins: [API],
    components: {
      DocumentEditorMain,
      ModuleEditorSidebar,
    },
    data() {
      return {
        module: {
          body: []
        },
        showModuleSidebar: true,
        moduleLoaded: false,
        saveTimer: 0,
      }
    },
    beforeMount() {
      this.fetchModule().then(() => {
        this.module.options = {
          documentFont: 'Helvetica'
        };
      });

      this.showModuleSidebar = (window.innerWidth > 1300);
      window.addEventListener('resize', this.onResize);
    },
    destroyed() {
      window.removeEventListener('resize', this.onResize);
    },
    methods: {
      onResize() {
        this.showModuleSidebar = (window.innerWidth > 1300);
      },
      fetchModule() {
        if (this.$route.params.id === 'new') {
          return this.api().createModule({ title: 'New Content Block' })
            .then(module => {
              this.module = module;
              this.$router.push(`/a/module/${this.module.id}`);
              this.moduleLoaded = true;
            });
        } else {
          return this.api().fetchModule(this.$route.params.id)
            .then(module => {
              this.module = module;
              this.moduleLoaded = true;
            });
        }
      },
      updateContent(options) {
        var part = _.findWhere(this.module.body, { id: options.part.id });

        if (part) {
          part.content = options.value;
        }
      },
      queueSave() {
        clearTimeout(this.saveTimer);
        this.saveTimer = setTimeout(this.saveModule, 5000);
      },
      saveModule() {
        clearTimeout(this.saveTimer);
        if (this.moduleLoaded) {
          this.api().updateModule(this.$route.params.id, this.module)
            .then(response => {
              (new Notyf()).confirm(this.$t('module_editor.saved'));
            }, response => {
              (new Notyf()).alert(this.$t('module_editor.saved_error'));
            });
        }
      }
    },
    watch: {
      'module': {
        handler: function() {
          this.queueSave();

          // Set default if whole document is deleted
          if (this.module.body && Array.isArray(this.module.body) && this.module.body.length <= 0) {
            this.$set(this.module, 'body', [{
              id: Math.floor(Math.random() * 100000000),
              type: 'text',
              icon: 'icon-p',
              title: 'Paragraph',
              content: '<p></p>'
            }]);
          }
        },
        deep: true
      }
    },
    destroyed() {
      clearTimeout(this.saveTimer);
    }
  }
</script>

<style lang="scss" scoped>
  @import "resources/assets/sass/layout/_variables";

  .fadeIn {
    animation-duration: 500ms;
  }
  .fadeInUp {
    animation-duration: 500ms;
  }

  .modal-background {
    background: darken($eggshell, 2%);
    position: fixed;
  }

</style>



// WEBPACK FOOTER //
// module-editor-modal.vue?68a8fcc9